import { render, staticRenderFns } from "./ReviewPaymentResume.vue?vue&type=template&id=5d4752cc&scoped=true"
import script from "./ReviewPaymentResume.vue?vue&type=script&lang=js"
export * from "./ReviewPaymentResume.vue?vue&type=script&lang=js"
import style0 from "./ReviewPaymentResume.vue?vue&type=style&index=0&id=5d4752cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4752cc",
  null
  
)

export default component.exports